import { Fragment } from 'react'
import Item from './item'
import Banners from '../banners'

interface ICashBoxesProps {
    cashBoxes: Array<ICashBoxes>
}

// See `moneyPools/index.tsx` — fragments so the tab's single gap governs the
// spacing, including around the banner slotted in after the first card.
export default function CashBoxes({ cashBoxes }: ICashBoxesProps) {
    return (
        <>
            {cashBoxes.map((item, index) => (
                <Fragment key={item.id}>
                    <Item item={item} />
                    {index === 0 && <Banners />}
                </Fragment>
            ))}
        </>
    )
}
